import axios from "axios";
import {API_URL} from "@env";

export const getSpeaker = async (speakerId) => {
    return axios.get(API_URL + `/speakers/getid/${speakerId}`);
}
